import { Component, inject, OnInit } from '@angular/core';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { InstanceService } from 'src/app/core/services/instance.service';

@Component({
  selector: 'app-overlay-loading',
  standalone: true,
  imports: [MatProgressSpinner],
  templateUrl: './overlay-loading.component.html',
  styleUrl: './overlay-loading.component.scss'
})
export class OverlayLoadingComponent implements OnInit {

  private _instance = inject(InstanceService);

  isLoading = false;

  protected instanceName!: string;

  ngOnInit() {
    this.instanceName = this._instance.getCurrentInstance();

    // setTimeout(() => {
    //   this.isLoading = false;
    // }, 1000);
  }

}
